import { render, staticRenderFns } from "./ProjectHomeDetails.vue?vue&type=template&id=0d571eb8"
import script from "./ProjectHomeDetails.vue?vue&type=script&lang=js"
export * from "./ProjectHomeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports